/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_text.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Converts an input value into text.',
  examples: [
    'ROW a = ["this", "is", "a", "text"]\n| EVAL text_a = TO_TEXT(a)',
  ],
  params: {
    field: 'Input value. The input can be a single- or multi-valued column or an expression.',
  },
};

export default docs;
